module.exports = __webpack_public_path__ + "media/images/map/car4-22f497663c425111907efecfbb2664b2.png";